import { t } from 'i18next';
import { UnitStatus, UnitStatusKey } from 'providers/types/unit';
import { Profile } from './userProfile';

export function handleUnitStatusString(production: string): string {
  switch (production) {
    case UnitStatus.INSTALLATION: return t('emInstalacao');
    case UnitStatus.OPERATION: return t('emOperacao');
    case UnitStatus.MODERNIZATION: return t('emModernizacao');
    case UnitStatus.FORCED_UNINSTALL: return t('desinstalacaoForcada');
    case UnitStatus.DEACTIVATED: return t('desmobilizada');
    default: throw new Error('Unit status not found');
  }
}

export function handleUnitStatusByProfile(profile: Profile): UnitStatusKey[] {
  const unitStatus: UnitStatusKey[] = ['OPERATION', 'MODERNIZATION', 'FORCED_UNINSTALL'];

  if (profile.manageAllClients) {
    unitStatus.push('INSTALLATION', 'DEACTIVATED');
  }

  return unitStatus;
}

export function getUnitStatusParams({ state, profile }): UnitStatusKey[] {
  const selected = state.selectedUnitStatus as UnitStatusKey[];
  if (selected.length > 0) return selected;
  const defaults: UnitStatusKey[] = ['OPERATION', 'MODERNIZATION', 'FORCED_UNINSTALL'];
  if (profile.manageAllClients || profile.permissions.isInstaller) defaults.push('INSTALLATION', 'DEACTIVATED');
  return defaults;
}

export function getUnitStatusOptions(profile: Profile) {
  const opts: { name: string, value: string }[] = [];
  if (profile.manageAllClients) {
    opts.push({ value: 'INSTALLATION', name: t('emInstalacao') });
  }
  opts.push(
    { value: 'OPERATION', name: t('emOperacao') },
    { value: 'MODERNIZATION', name: t('emModernizacao') },
    { value: 'FORCED_UNINSTALL', name: t('desinstalacaoForcada') },
    { value: 'DEACTIVATED', name: t('desmobilizada') },
  );
  return opts;
}
